import { render, staticRenderFns } from "./ServiceEnterprise.vue?vue&type=template&id=2888c545&scoped=true"
import script from "./ServiceEnterprise.vue?vue&type=script&lang=js"
export * from "./ServiceEnterprise.vue?vue&type=script&lang=js"
import style0 from "./ServiceEnterprise.vue?vue&type=style&index=0&id=2888c545&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888c545",
  null
  
)

export default component.exports